module.exports = __webpack_public_path__ + "img/header-single-v2.0cb41507.png";